import guessCountryFromDialCode from 'I18n/utils/guessCountryFromDialCode';
import { ValidationStatus } from 'signup-ui-lego-core/types';
const MIN_USER_DIGITS_LENGTH = 4;
const getNumberDigits = phoneNumber => {
  return phoneNumber.replace(/\D/g, '');
};
const getUserEnteredDigits = phoneNumber => {
  const digits = getNumberDigits(phoneNumber);
  if (!digits) {
    return '';
  }
  const country = guessCountryFromDialCode(digits);
  const dialCode = (country === null || country === void 0 ? void 0 : country.dialCode) || '';
  return digits.replace(dialCode, '');
};
export const syncPhoneValidator = phoneNumber => {
  if (!phoneNumber) {
    return ValidationStatus.INVALID;
  }
  const userEnteredDigits = getUserEnteredDigits(phoneNumber);
  if (userEnteredDigits.length < MIN_USER_DIGITS_LENGTH) {
    return ValidationStatus.INVALID;
  }
  return ValidationStatus.VALID;
};